import {Component, DoCheck, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {InsuranceCompany} from '../../../../shared/interface/insurance-company';
import {ReplaySubject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../../shared/services/form-helper.service';
import {DictService} from '../../../../shared/services/dict.service';
import {first, startWith, takeUntil} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {CommissionAnnexService} from '../../../../shared/services/commission-annex.service';
import {FilterService} from "../../../../shared/services/filter.service";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-add-annex',
  templateUrl: './add-annex.component.html',
  styleUrls: ['./add-annex.component.scss']
})
export class AddAnnexComponent implements OnInit, OnDestroy{
  annexConfigurationForm: FormGroup;
  insuranceCompanyControl: FormControl;
  internalRiskControl: FormControl;
  importerControl: FormControl;
  partnerControl: FormControl;
  ofwcaControl: FormControl;
  policyTypesControl: FormControl;
  ratePaidControl: FormControl;
  activeFromControl: FormControl;
  activeToControl: FormControl;
  activePolicyFromControl: FormControl;
  activePolicyToControl: FormControl;
  customerNameControl: FormControl;
  policyNumberControl: FormControl;
  processingRequest = false;
  overvoltage: FormControl;
  overvoltageShow = false;
  errors: any = {};
  selectedInsuranceCompany: InsuranceCompany;
  initialFilters: any;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private dictService: DictService,
    private commissionAnnexService: CommissionAnnexService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private snack: MatSnackBar,

  ) {
    this.annexConfigurationForm = this.fb.group({
      partner: this.partnerControl = fb.control('', []),
      ofwca: this.ofwcaControl = fb.control('', []),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      internalRisk: this.internalRiskControl = fb.control('', []),
      importer: this.importerControl = fb.control(''),
      policyTypes: this.policyTypesControl = fb.control([]),
      ratePaid: this.ratePaidControl = fb.control(''),
      activeFrom: this.activeFromControl = fb.control(''),
      activeTo: this.activeToControl = fb.control(''),
      customerName: this.customerNameControl = fb.control(''),
      policyNumber: this.policyNumberControl = fb.control(''),
      activePolicyFrom: this.activePolicyFromControl = fb.control(''),
      activePolicyTo: this.activePolicyToControl = fb.control(''),
      overvoltage: this.overvoltage = fb.control(false),
    });

  }

  ngOnInit(): void {
    this.overvoltage.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        startWith(false)
      ).subscribe((value: boolean) => {
      if (value) {
        this.overvoltageShow = true;
        this.ofwcaControl.setValidators([Validators.required]);
      } else {
        this.overvoltageShow = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(addNext = false): void {

    let textInfo;
    const partner = this.partnerControl.value;
    const ofwca = this.ofwcaControl.value;
    if (this.overvoltage.value){
      textInfo = 'Wybrana OFWCA posiada już aneks w tym TU. Czy chcesz dodać kolejny?';
    } else {
      textInfo = 'Wybrany Partner posiada już aneks w tym TU. Czy chcesz dodać kolejny?';
    }
    this.commissionAnnexService.findAnnex({
      partner,
      ofwca,
      insuranceCompany: this.insuranceCompanyControl.value,
      importer: this.importerControl.value,
      overvoltage: this.overvoltage.value
    })
      .pipe()
      .subscribe((result) => {

        if (result.items.length){

          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '750px',
            data: {text: textInfo},
          });
          dialogRef.afterClosed().subscribe(resultDialogRef => {
            if (resultDialogRef) {
              this.snack.open('Pomyślnie dodano annex', '', {duration: 2000});
              this.processingRequest = true;
              this.sendForm(addNext);
            }
          });
        } else{
          this.processingRequest = true;
          this.sendForm(addNext);
        }

      });
  }

  cancel(): void {
    this.router.navigate(['/aneksy']);
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.importerControl.setValue('');
    this.selectedInsuranceCompany = insuranceCompany;
  }

  sendForm(addNext): void {
    this.commissionAnnexService.sendForm(
      this.annexConfigurationForm.value,
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open('Pomyślnie utworzono konfigurację', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        if (addNext) {
          this.annexConfigurationForm.reset({
            overvoltage: this.overvoltage.value,
            partner: this.partnerControl.value,
            ofwca: this.ofwcaControl.value,
            insuranceCompany: this.insuranceCompanyControl.value,
            internalRisk: '',
            importer: this.importerControl.value || '',
            policyTypes: [],
            ratePaid: '',
            activeFrom: '',
            activeTo: '',
            activePolicyFrom: '',
            activePolicyTo: '',
            customerName: '',
            policyNumber: '',
          });
        } else {
          this.router.navigate(['/aneksy', {uuid: response.uuid}]);
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.annexConfigurationForm, this.errors);
        }
      });
  }
}
